import { render, staticRenderFns } from "./PublishResourceConfirm.vue?vue&type=template&id=51c076a0&"
import script from "./PublishResourceConfirm.vue?vue&type=script&lang=ts&"
export * from "./PublishResourceConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports